import * as React from "react";
import ScrollBar from "react-perfect-scrollbar";
import { selectBalancingCharacter } from "../../../../balancingSelectors/selectBalancingCharacters";
import { ScrollOptions } from "../../../../constants/ScrollOptions";
import { ThemedEventConstants } from "../../../../constants/ThemedEventConstants";
import { IdStyles } from "../../../../less/IdStyles";
import { selectEventEndTime } from "../../../../selectors/selectEventInfo";
import { IdLoca } from "../../../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../../../utils/i18n/ReplacementLoca";
import { utilNumber } from "../../../../utils/utilNumber";
import { TextLoca } from "../../../generic/text/TextLoca";
import { TimeRemaining } from "../../../time/TimeRemaining";
import { ThemedEventIcon } from "../ThemedEventIcon";
import { getQuestProfile } from "./tasks/getQuestIcon";
export var QuestItemDescription = function (_a) {
    var isCompleted = _a.isCompleted, quest = _a.quest, themedEventInfo = _a.themedEventInfo, onThemedEventIconClick = _a.onThemedEventIconClick, eventInfo = _a.eventInfo, getQuestEndTime = _a.getQuestEndTime;
    {
        if (themedEventInfo == undefined) {
            return React.createElement(React.Fragment, null);
        }
        var npcId = parseInt(quest.npc, 10);
        var questCharacter = selectBalancingCharacter(npcId);
        var profilePicture = questCharacter
            ? questCharacter.profilePictureAsset
            : quest.buttonIconLeft;
        var profileClassName = getQuestProfile(profilePicture);
        var themedEventIcon = getThemedEventIcon(quest, themedEventInfo, onThemedEventIconClick);
        var endTime = getEndTime(eventInfo, isCompleted, quest, getQuestEndTime);
        var locaReplacements = new Map();
        var questEpisode = React.createElement(React.Fragment, null);
        if (quest.episode) {
            locaReplacements.set(ReplacementLoca.zero_0, utilNumber.format(quest.episode));
            locaReplacements.set(ReplacementLoca.one_1, utilNumber.format(ThemedEventConstants.eventTotalEpisodes));
            questEpisode = (React.createElement(TextLoca, { replacements: locaReplacements, id: IdLoca.value_proportional_value }));
        }
        return (React.createElement("div", { key: quest.locaKeyIdle, className: "quest-item-description__container" },
            React.createElement("div", { className: "flex flex--stacked flex--guts quest-item-description__container--context" },
                themedEventIcon,
                React.createElement("div", { className: profileClassName }),
                endTime),
            React.createElement("div", { className: IdStyles.QuestDescriptionBackground + " description__context" },
                React.createElement("label", { className: "flex flex--guts title " + IdStyles.TextBoldAccent },
                    React.createElement(TextLoca, { id: quest.locaKeyTitle }),
                    "\u00A0\u00A0",
                    questEpisode),
                React.createElement("div", { className: "description" },
                    React.createElement(ScrollBar, { component: "div", options: ScrollOptions, className: "w100 quest-item-description__balloon-description" },
                        React.createElement(TextLoca, { id: isCompleted ? quest.locaKeyEnd : quest.locaKeyIdle, className: "" + IdStyles.TextNormal }))))));
    }
};
var getThemedEventIcon = function (quest, themedEventInfo, onThemedEventIconClick) {
    return quest.eventId && themedEventInfo && themedEventInfo.id === quest.eventId ? (React.createElement(ThemedEventIcon, { icon: themedEventInfo.icon, onClick: onThemedEventIconClick })) : (React.createElement(React.Fragment, null));
};
var getEndTime = function (eventInfo, isCompleted, quest, getQuestEndTime) {
    var endTime = eventInfo ? selectEventEndTime(eventInfo.proto) : getQuestEndTime(quest.id);
    var showEndTime = (eventInfo && endTime) || (endTime && !isCompleted);
    if (!showEndTime) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: "quest-item-description__container-timer" },
        React.createElement(TimeRemaining, { remainingTime: endTime })));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/quest/list/QuestItemDescription.tsx
// module id = 2661
// module chunks = 3